// Dependency-free SEO/locale constants shared by the Edge middleware and the
// server components. Keep this in sync with settings.translation_system and
// settings.website_domain (config/settings.tsx can't be imported from the
// middleware: it pulls in React icon components).

export const CANONICAL_HOST = 'www.apect.net';
export const SITE_URL = `https://${CANONICAL_HOST}`;
export const DEFAULT_LOCALE = 'en';
// Locales served under a /<locale> URL prefix (the default has no prefix).
export const PREFIXED_LOCALES = ['fr', 'es'];

export const LOCALE_HEADER = 'x-apect-locale';
export const PATHNAME_HEADER = 'x-apect-pathname';

// Path prefixes that are not public content: no canonical/hreflang for these.
const PRIVATE_PREFIXES = [
  '/panel', '/admin', '/subscriptions', '/account', '/server', '/create', '/login', '/register',
  '/reset-password', '/check-email', '/suspended', '/auth', '/test-stack', '/ads', '/users',
];

export function isPublicPath(pathname) {
  return !PRIVATE_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`));
}

// Absolute URL of `pathname` in `locale`.
export function localizedUrl(pathname, locale) {
  const path = pathname === '/' ? '' : pathname;
  return locale === DEFAULT_LOCALE ? `${SITE_URL}${path || '/'}` : `${SITE_URL}/${locale}${path}`;
}
